import type { GetActionPlansResponse } from '@/types/Psychosocial';
import type { GetActionPlansResponseDTO } from '@/core/dto/psychosocial-report';

export class GetActionPlansMapper {
	constructor(private readonly data: GetActionPlansResponseDTO) {}

	toDomain(): GetActionPlansResponse {
		return this.data;
	}
}
